import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Tooltip from 'rc-tooltip';
import Confirm from '../../components/Confirm.js';
import General from '../../modules/General';
import GeneralHelper from '../../helpers/General.js';
import moment from 'moment';
import Portal from 'react-portal';
import FullScreenOverlay from '../../components/FullScreenOverlay.js';
import SegmentsNew from "./SegmentsNew";
import AskUpgrade from "../../components/AskUpgrade";
import {setSegments,updateSegment} from '../../actions/Segment';
import TimeAgo from 'react-timeago'

class Segments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            isError:false,
            askDelete:false,
            askUpgrade:false,
            showDialog:false,
            currentSegment:false,
            segments:[],
            segment:{},
        }

        this.rows = this.rows.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.getSegments = this.getSegments.bind(this);
        this.runSegment = this.runSegment.bind(this);
    }

    runSegment(index) {
        let segment = {
            ...this.props.segments.list[index]
        }

        segment.is_running = 1;

        this.props.updateSegment(index,segment);

        axios.post('/segments/'+segment.id+'/generate');

    }

    getSegments() {
        this.setState({
            ...this.state,
            'isLoading':true,
        });

        axios.get(`/segments`)
            .then(res => {

                this.props.setSegments(res.data);

                this.setState({
                    ...this.state,
                    'isError':false,
                    'isLoading':false,
                });

            })
            .catch(res => {
                this.setState({'isError':res.message});
            });
    }


    handleSave() {
        this.getSegments();
    }



    placeholder() {
        return <span className="tag tag-default" style={{display:'inline-block',width:'35%'}}>&nbsp;</span>;
    }

    rows() {
        let data = this.placeholderRow(10,6);

        this.props.segments.list.map((segment,i) => {
            data[i] =
                <tr key={`segment-${segment.id}`}>
                    <td>#{segment.id}</td>
                    <td>{segment.name}</td>
                    <td>
                        {
                            segment.is_running == '1' ?
                                <button className={`btn btn-warning btn-sm`}>
                                    <div style={{display:'inline-block'}}>
                                        <div className="loading-small" style={{float:'left'}}></div>
                                        <div style={{display:'inline-block',paddingTop:'0px',paddingLeft:'5px'}} >
                                            Processing
                                        </div>
                                    </div>
                                </button>
                                :
                                <button className={`btn  btn-success btn-sm`} onClick={e => { e.stopPropagation(); this.runSegment(i) }}><i className="icon wb-play"></i>Generate segment</button>
                        }
                    </td>
                    <td>
                        {
                            segment.last_run && segment.is_running == '0' ?
                                <a href={segment.url} target="blank" style={{textDecoration:'none'}} className={`btn btn-dark btn-sm`}>Download</a>
                            :
                                <Tooltip placement="top" overlay={<span>You must run the segment before you can download the results</span>}>
                                    <button className={`btn btn-dark btn-sm`} disabled={true}>Download</button>
                                </Tooltip>
                        }
                    </td>
                    <td>
                        {
                            segment.last_run ?
                                moment(GeneralHelper.toLocalTime(segment.last_run)).fromNow()
                                :'Never'
                        }
                    </td>
                    <td>
                        <div className="btn-group" role="group">
                            <Tooltip placement="top" overlay={<span>Edit segment</span>}>
                                <button onClick={e => { e.stopPropagation(); this.setState({currentSegment:segment.id,showDialog:true}) }} className="btn btn-icon btn-default btn-outline"><i className="icon wb-pencil" aria-hidden="true"></i></button>
                            </Tooltip>
                            <Tooltip placement="top" overlay={<span>Delete segment</span>}>
                                <button onClick={(e) => {this.askDelete(segment.id)}} type="button" className="btn btn-icon btn-default btn-outline"><i className="icon wb-trash" aria-hidden="true"></i></button>
                            </Tooltip>
                        </div>
                    </td>
                </tr>

        })

        return data;
    }

    askDelete(id) {
        this.setState({askDelete:id});
    }

    delete(id) {
        this.setState({askDelete:false,isLoading:true});
        axios.delete('/segments/'+id).then(res => {
            axios.get(`/segments`)
                .then(res => {
                    this.getSegments();
                });
        });
    }

    placeholderRow(rows,cols) {
        let td = [];
        for(let i = 1;i<=cols;i++) {
            td.push(<td key={i}>{this.placeholder()}</td>);
        }

        let row = [];
        for(let i = 1;i<=rows;i++) {
            row.push(<tr key={i}>{td}</tr>);
        }

        return row;
    }

    componentWillMount() {
        this.getSegments();


    }

    render() {
        if(this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }

        if(this.state.askUpgrade) {
            return  <AskUpgrade inline onAccept={(e) => { this.setState({askUpgrade:false}); this.props.router.push(General.Link('/settings/billing/plan')) }} onClose={() => {this.setState({askUpgrade:false})}} param={this.state.askUpgrade} title="Upgrade required" body="To use this feature you must upgrade to a larger package." />
        }

        return (
            <div className="full-height">
                <div className="page-header">
                    <span className="page-title"><i className="icon fa-code-fork"></i> Segments</span>
                    <div className="page-header-actions">
                        <button onClick={e => { e.stopPropagation(); this.setState({currentSegment:false,showDialog:true}) }} className="btn btn-dark"><i className="icon fa-plus" style={{marginRight:'10px'}}></i>  New segment</button>
                    </div>
                </div>
                <div className="page-content">
                    <div className="col-sm-12 p-0">
                        <Helmet title="Segments | Crall.io" />


                        <table className="table outline">
                            <tbody>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Run</th>
                                <th>Download</th>
                                <th>Last export</th>
                                <th>Actions</th>
                            </tr>
                            </tbody>

                            <tbody>
                            {this.props.segments.list.length == 0 ?
                                this.placeholderRow(10,6)
                                :this.rows()}
                            </tbody>
                        </table>
                        <Confirm onAccept={(e) => { this.delete(e) }} onClose={() => {this.setState({askDelete:false})}} param={this.state.askDelete} title="Are you sure?" body="Do you want to delete this popup?" />
                    </div>
                </div>

                <Portal closeOnEsc onClose={e => {this.setState({currentSegment:false,showDialog:false})}} isOpened={this.state.showDialog}>
                    <FullScreenOverlay>
                        <SegmentsNew handleSave={this.handleSave} enabled={this.props.general.settings.PACKAGE_SEGMENTS} exportable={1} onClose={e => {this.setState({currentSegment:false,showDialog:false})}} segmentId={this.state.currentSegment} />
                    </FullScreenOverlay>
                </Portal>


            </div>



        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general,
        segments:state.segments
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setSegments,updateSegment},dispatch)
}


Segments = connect(mapStateToProps,mapDispatchToProps)(Segments);
export default Segments;


// WEBPACK FOOTER //
// ./containers/segments/segments.js